import cookiesHelper, {
    setCookie as setHelper,
    getCookie as getHelper,
    removeCookie as removeHelper,
    getAllCookies as getAllHelper,
} from './cookies';
import {
    setPublisherCookie as setPublisherHelper,
    getPublisherCookie as getPublisherHelper,
} from './cookies-publisher';
import {
    setPersonCookie as setPersonHelper,
    getPersonCookie as getPersonHelper,
    removePersonCookie as removePersonHelper,
} from './cs-person';
import {
    setVisitedSiteCookie as setVisitedSiteHelper,
    getVisitedSiteCookie as getVisitedSiteHelper,
    removeVisitedSiteCookie as removeVisitedSiteHelper,
} from './visited-site';
import {
    setSessionCookie as setSessionHelper,
    getSessionCookie as getSessionHelper,
    removeSessionCookie as removeSessionHelper,
} from './cookies-session';
import * as consts from './constants';

export const cookies = cookiesHelper;
export const getAllCookies = getAllHelper;
export const setCookie = setHelper;
export const getCookie = getHelper;
export const removeCookie = removeHelper;
export const getPersonCookie = getPersonHelper;
export const setPersonCookie = setPersonHelper;
export const removePersonCookie = removePersonHelper;
export const getVisitedSiteCookie = getVisitedSiteHelper;
export const setVisitedSiteCookie = setVisitedSiteHelper;
export const removeVisitedSiteCookie = removeVisitedSiteHelper;
export const getPublisherCookie = getPublisherHelper;
export const setPublisherCookie = setPublisherHelper;
export const setSessionCookie = setSessionHelper;
export const getSessionCookie = getSessionHelper;
export const removeSessionCookie = removeSessionHelper;
export const constants = consts;
